import { Box, CircularProgress, styled } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';

import { Size } from 'theme/enums';

interface IProps {
  fullHeight?: boolean;
  alignItems?: string;
  size?: Size;
  style?: SxProps;
}

const propsToSkip = ['fullHeight'];
const shouldForwardProp = (prop: string) => !propsToSkip.includes(prop);

export const Wrapper = styled(Box, { shouldForwardProp })<IProps>(({ fullHeight }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: fullHeight ? '100vh' : '100%',
  margin: 8,
}));

export const Loader = ({
  fullHeight = false,
  alignItems = 'center',
  size = Size.MD,
  style = {},
}: IProps) => {
  return (
    <Wrapper fullHeight={fullHeight} sx={{ ...style, alignItems }}>
      <CircularProgress size={size} />
    </Wrapper>
  );
};
